const installationInstructions = {
  powerDevice: {
    currentStep: 'powerDevice',
    nextStep: 'confirmPairingMode',
    nextStepName: 'categoryInstructions',
    prevStepName: 'https://return-to-app',
    headerOverridingClass: 'background-gray',
    resource: require('@/assets/categories/light_strip/light_strip_power.png'),
    resourceType: 'image',
    primaryTx: 'categories.light_strip.powerDevice.title',
    secondaryTx: 'categories.light_strip.powerDevice.subtitle',
    continueButtonTx: 'common.continue',
    alternateNextStep: {
      nextStep: 'resetDevice',
      nextStepName: 'categoryInstructions',
      lastStep: 'powerDevice',
      titleTx: 'categories.light_strip.stepsToReset',
    },
  },
  confirmPairingMode: {
    currentStep: 'confirmPairingMode',
    prevStep: 'powerDevice',
    prevStepName: 'categoryInstructions',
    headerOverridingClass: 'background-gray',
    resource: require('@/assets/categories/light_strip/light_strip_pairing_mode.png'),
    resourceType: 'image',
    primaryTx: 'categories.light_strip.confirmPairingMode.title',
    secondaryTx: 'categories.light_strip.confirmPairingMode.subtitle',
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
    primaryActionKey: 'chooseProvider', // Choose Pepper or Tuya FW
    continueButtonTx: 'common.continue',
    alternateNextStep: {
      nextStep: 'resetDevice',
      nextStepName: 'categoryInstructions',
      lastStep: 'confirmPairingMode',
      titleTx: 'categories.light_strip.stepsToReset',
    },
  },
  resetDevice: {
    headerIcon: 'closeBlack',
    prevStep: 'powerDevice',
    prevStepName: 'categoryInstructions',
    currentStep: 'resetDevice',
    nextStep: 'confirmPairingMode',
    nextStepName: 'categoryInstructions',
    headerOverridingClass: 'background-gray',
    headerTitleTx: 'categories.light_strip.stepsToReset',
    carousel: {
      showPageIndicator: true,
      slides: [
        {
          resourceType: 'image',
          resource: require('@/assets/categories/appliance/reset_appliance_step_1.png'),
          primaryTx: 'categories.light_strip.resetDevice.step1.title',
          secondaryTx: 'categories.light_strip.resetDevice.step1.subtitle',
        },
        {
          resourceType: 'image',
          resource: require('@/assets/categories/appliance/reset_appliance_step_2.png'),
          primaryTx: 'categories.light_strip.resetDevice.step2.title',
          secondaryTx: 'categories.light_strip.resetDevice.step2.subtitle',
        },
        {
          resourceType: 'image',
          resource: require('@/assets/categories/light_strip/reset_light_strip_step_3.gif'),
          primaryTx: 'categories.light_strip.resetDevice.step3.title',
          secondaryTx: 'categories.light_strip.resetDevice.step3.subtitle',
        }
      ]
    }
  },
};

export default installationInstructions;
